import type { AdminDashboardBreakdownProps } from "../../models/admin-dashboard.models";
import { ADMIN_DASHBOARD_TONE_CLASSES } from "../../utils/admin-dashboard.constants";

// Independent bars preserve overlapping categories such as document expiry and overdue surveys.
// Zero stays at zero rather than receiving an artificial minimum bar length.
const AdminDashboardBreakdown = ({ breakdown }: AdminDashboardBreakdownProps) => {
  const items = breakdown.items.slice(0, 4);
  const maxValue = Math.max(1, ...items.map((item) => item.value));

  return (
    <figure data-test={`admin-dashboard-chart-${breakdown.key}`}>
      <figcaption className="mb-3 text-xs opacity-60">{breakdown.title}</figcaption>
      {items.length === 0 ? (
        <p className="py-3 text-xs opacity-60">No records yet.</p>
      ) : (
        <ul className="space-y-2.5">
          {items.map((item) => (
            <li
              key={item.label}
              className="grid grid-cols-[minmax(0,1fr)_minmax(48px,1fr)_auto] items-center gap-3 text-xs"
            >
              <span className="truncate" title={item.label}>
                {item.label}
              </span>
              <div aria-hidden="true" className="h-1.5 overflow-hidden rounded-full bg-[#E9F4F3] dark:bg-gray-700">
                <div
                  className="h-full rounded-full bg-current text-green dark:text-teal-400"
                  style={{ width: `${Math.max(0, item.value / maxValue) * 100}%` }}
                />
              </div>
              <span
                className={`min-w-[2ch] text-right font-medium tabular-nums ${ADMIN_DASHBOARD_TONE_CLASSES[item.tone ?? "neutral"]}`}
              >
                {item.value.toLocaleString()}
              </span>
            </li>
          ))}
        </ul>
      )}
    </figure>
  );
};

export default AdminDashboardBreakdown;
